import { createLogger } from 'shared/services/logger';
import { LAYER_TYPES } from 'shared/stores/annotations';
import { WV_LAYER_NAMES } from 'shared/stores/annotations/consts';

const logger = createLogger('UScope:extensions:annotations:color');

export const colorTool = {
  install (toolbox) {
    const tool = {
      action () {
        const annotationsService = this.VIEWPORT.plugins('us:annotations:service');
        const colorPicker = this.USCOPE.plugins('us:annotations:color-picker');
        if (!colorPicker) {
          logger.warn('color picker is not available.');
          return;
        }

        const color = annotationsService.getSelColor();
        colorPicker.toggle(color);
      },

      isEnabledDelegate () {
        // Only change color of web viewer regions
        const layer = this.ANNOTATIONS.selectedRegionLayer;
        const result = layer ? (
          layer.name === WV_LAYER_NAMES.ANNOTATION ||
          layer.type === LAYER_TYPES.REPORT
        ) : false;

        return {or: result};
      }
    };

    return toolbox.extend('color', tool);
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/color.js